<a (click)="onToggleCollapse()" id="btn-menuLock-collapse"><i class="icon-ic-double-chevron-s1"></i></a>
